import LegalLayout from "@/components/legal/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout title="Terms of Use" effectiveDate="February 13, 2026">
      <p>
        These Terms of Use (&ldquo;<strong>Terms</strong>&rdquo;) govern your access to and use of the Business Showers website at
        <a href="https://pitch.businessshowers.org"> pitch.businessshowers.org</a> and any subdomains, apps, or event experiences we
        operate (together, the &ldquo;<strong>Service</strong>&rdquo;). The Service is provided by <strong>Freedom In Me</strong>, a
        community organization based in Charlotte, NC.
      </p>
      <p>
        By using the Service you agree to these Terms and to our{" "}
        <a href="/privacy">Privacy Policy</a> and <a href="/photo-release">Photo &amp; Video Release</a>. If you do not agree, please do not use the Service.
      </p>

      <h2>1. Who May Use the Service</h2>
      <ul>
        <li>You must be at least 18 years old to submit any form or opt into email or SMS.</li>
        <li>You agree to provide accurate information when you check in, register, or submit any form.</li>
        <li>You agree not to impersonate another person or check in on behalf of someone without their permission (walk-ins for a specific person are allowed with their consent).</li>
      </ul>

      <h2>2. Event Participation</h2>
      <p>
        Attending a Business Showers event — including the 2026 VIP Networking Experience (July 17) and the 2026 Business Showers ceremony
        (July 18) — is subject to venue rules, safety guidelines, and any published event code of conduct. We may deny entry or ask an attendee to leave
        if they behave in a way that endangers or harasses others.
      </p>

      <h2>3. Communications You Opt Into</h2>

      <h3>Email</h3>
      <p>
        We send email only to people who have opted in through a specific form (2027 Early Access, volunteer sign-up, sponsor inquiry, etc.).
        Every email includes a one-click unsubscribe link.
      </p>

      <h3>SMS</h3>
      <p>
        SMS is opt-in only. The opt-in is presented on-site at the check-in form. By checking the SMS consent box you agree to receive:
      </p>
      <ul>
        <li>A one-time check-in confirmation text with a link to the digital program.</li>
        <li>Optional same-day event updates (typically 0–1 additional messages during the event).</li>
        <li>An optional post-event thank-you text with the photo album link, within 30 days of the event.</li>
      </ul>
      <p>
        Message frequency: typically 1–3 messages per event cycle. <strong>Message and data rates may apply.</strong>
        Reply <code>STOP</code> to opt out at any time. Reply <code>HELP</code> for help, or email
        <a href="mailto:info@itsthefreedominme.com"> info@itsthefreedominme.com</a>.
      </p>
      <p>
        <strong>We do not send marketing or promotional SMS to ticket registrants in advance of the event.</strong>
        The SMS opt-in only occurs on event day, at the check-in kiosk.
      </p>

      <h2>4. Donations</h2>
      <p>
        Donation buttons on the Service link to third-party payment processors we designate. We do not process card information on our own servers.
        Donations to Freedom In Me may be tax-deductible if we are recognized as a 501(c)(3) organization at the time of your gift — please consult
        your tax advisor and refer to our donation acknowledgment for the current tax status.
      </p>

      <h2>5. Ticketing &amp; Refunds</h2>
      <p>
        Tickets to Business Showers events are sold through Eventbrite (or another third-party ticket platform we designate). Refund and cancellation
        policies are governed by that platform's terms at the time of purchase. Please review those terms before completing a ticket purchase.
      </p>

      <h2>6. Photos &amp; Recording</h2>
      <p>
        Business Showers events are photographed and recorded. Attendance implies consent to appear in event photography, livestream footage, and post-event
        recap content, subject to our <a href="/photo-release">Photo &amp; Video Release</a>. See that page for how to request removal of a specific image.
      </p>

      <h2>7. Intellectual Property</h2>
      <ul>
        <li>&ldquo;Freedom In Me,&rdquo; &ldquo;Business Showers,&rdquo; the event artwork, honoree list, and site content are our property or used with permission.</li>
        <li>Attendee-submitted photos remain the property of the attendee, subject to the license granted in the Photo &amp; Video Release.</li>
        <li>You may not reproduce, resell, or commercially exploit the Service without prior written permission.</li>
      </ul>

      <h2>8. Acceptable Use</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Submit false, misleading, or automated form entries.</li>
        <li>Attempt to access administrator, volunteer, or manager areas without authorization.</li>
        <li>Interfere with the Service, its security, or the check-in flow of other attendees.</li>
        <li>Use the Service to harass, defame, or threaten anyone.</li>
      </ul>

      <h2>9. Third-Party Services</h2>
      <p>
        The Service integrates with third-party providers (Twilio for SMS, Resend for email, Google for administrator sign-in, Eventbrite or similar for tickets,
        and a photo-sharing platform we designate — currently Kululu). Their respective privacy policies and terms apply to any information you share with them.
      </p>

      <h2>10. Disclaimer &amp; Limitation of Liability</h2>
      <p>
        The Service is provided <strong>as-is</strong>, without warranties of any kind. To the fullest extent permitted by law, Freedom In Me will not be liable
        for any indirect, incidental, or consequential damages arising out of your use of the Service or attendance at an event.
      </p>

      <h2>11. Changes to the Service or these Terms</h2>
      <p>
        We may update these Terms from time to time. Material changes will be posted here with a new effective date. Continued use of the Service after an update
        indicates your acceptance of the revised Terms.
      </p>

      <h2>12. Governing Law</h2>
      <p>
        These Terms are governed by the laws of the State of North Carolina, USA, without regard to conflict-of-laws principles. Any dispute will be resolved in
        the state or federal courts located in Mecklenburg County, North Carolina.
      </p>

      <h2>13. Contact</h2>
      <p>
        <strong>Freedom In Me</strong><br />
        Charlotte, NC<br />
        <a href="mailto:info@itsthefreedominme.com">info@itsthefreedominme.com</a>
      </p>
    </LegalLayout>
  );
}
